export const setProcessors = 'setProcessors'
export const setCustomFields = 'setCustomFields'
export const setAddressFound = 'setAddressFound'
export const setPaymentMethod = 'setPaymentMethod'
export const cardMethod = 'cardMethod'
export const transferMethod = 'transferMethod'
export const balanceMethod = 'balanceMethod'
export const setPaymentMethods = 'setPaymentMethods'
export const setWebhookSettings = 'setWebhookSettings'
export const setBillingSettings = 'setBillingSettings'
export const billetMethod = 'billetMethod'
export const clearPaymentMethods = 'clearPaymentMethods'
export const setCustomFieldsValues = 'setCustomFieldsValues'
export const setGatewayFieldsValues = 'setCustomFieldsValues'
export const setFilterPaymentMethod = 'setFilterPaymentMethod'
export const setPaymentMethodConfigs = 'setPaymentMethodConfigs'
export const clearFilterPaymentMethod = 'clearFilterPaymentMethod'
export const clearFilterPaymentMethods = 'clearFilterPaymentMethods'
export const reprocessCardMethod = 'reprocessCardMethod'
export const reprocessBilletMethod = 'reprocessBilletMethod'
export const setBillingSettingsConfigs = 'setBillingSettingsConfigs'
export const setWebhookSettingsConfigs = 'setWebhookSettingsConfigs'
export const setNfeSettings = 'setNfeSettings'
export const setNfeSettingsConfigs = 'setNfeSettingsConfigs'
export const yapayToken = 'yapayToken'



// WEBPACK FOOTER //
// ./src/app/pages/settings/vuex/mutations-types.js